import React, { useEffect } from "react";

export const MyAccount = () => {
  useEffect(() => {}, []);

  return (
    <>
      <h1>My account</h1>
    </>
  );
};
